//TODO - FIXME
// tslint:disable: no-commented-code
// tslint:disable: member-access
/**
 * @author Ivan Toth.
 * Saves, calculates data for data displayed in Details section
 */
//NOTE: eligibility decision should correspond to the enum EligibilityDecision in common/server/...
var EligibilityDecision;
(function (EligibilityDecision) {
    // common decisions
    EligibilityDecision[EligibilityDecision["FULLY_ELIGIBLE"] = 'Fully Eligible'] = "FULLY_ELIGIBLE";
    EligibilityDecision[EligibilityDecision["PARTIALLY_ELIGIBLE"] = 'Partially Eligible'] = "PARTIALLY_ELIGIBLE";
    EligibilityDecision[EligibilityDecision["SPECIAL_BID_ONLY"] = 'Special Bid Only'] = "SPECIAL_BID_ONLY";
    EligibilityDecision[EligibilityDecision["REJECTED"] = 'Rejected'] = "REJECTED";
    EligibilityDecision[EligibilityDecision["UNKNOWN"] = 'Unknown'] = "UNKNOWN";
    // opp v3 decisions
    EligibilityDecision[EligibilityDecision["SOLUTION_ONLY"] = 'Solution Only'] = "SOLUTION_ONLY";
    EligibilityDecision[EligibilityDecision["SOLUTION_AND_SPECIAL_BID_ONLY"] = 'Solution and Special Bid Only'] = "SOLUTION_AND_SPECIAL_BID_ONLY";
    // opp v4 decisions
    EligibilityDecision[EligibilityDecision["ENGAGEMENT_ONLY"] = 'Engagement Only'] = "ENGAGEMENT_ONLY";
    EligibilityDecision[EligibilityDecision["ENGAGEMENT_AND_SPECIAL_BID_ONLY"] = 'Engagement and Special Bid Only'] = "ENGAGEMENT_AND_SPECIAL_BID_ONLY";
})(EligibilityDecision || (EligibilityDecision = {}));
var TopicService = (function () {
    function TopicService($rootScope, $timeout, $q, socket, config, _, status, settings, env, $state, notify, Dialog) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$q = $q;
        this.socket = socket;
        this.config = config;
        this._ = _;
        this.status = status;
        this.settings = settings;
        this.env = env;
        this.$state = $state;
        this.notify = notify;
        this.Dialog = Dialog;
        this.usFed = { status: false, beingDeleted: false }; //Flag that if set to true would mean user MUST cease processing
        this.goeFired = false;
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_5 = 5;
        this.socket.on('connect', function () {
            _this.connected = true;
            var propArray = [];
            for (var prop in _this.editableComponents) {
                propArray.push(prop);
            }
            _this.updateSocketStatus(propArray);
        });
        this.socket.on('disconnect', function () {
            _this.connected = false;
            var propArray = [];
            for (var prop in _this.editableComponents) {
                propArray.push(prop);
            }
            _this.updateSocketStatus(propArray);
        });
        this.topicObjTemplate = {
            loaded: false,
            identifier: '',
            mgr: {},
            cl: {},
            fastpass: {},
            fastpass_valid: {},
            gpp: {},
            goe_data: {},
            goe_valid: {},
            goe_valid_data: {},
            cmr_valid_data: {},
            cmr: {},
            sc: {},
            pw: {},
            bpims: {},
            dc: {},
            dc_mysa: {},
            dc_sc: {},
            pd: {},
            complcl: {},
            complcl2: {},
            complcl3: {},
            complcl4: {},
            complcl_validation: {},
            complcl_calculation: {},
            complcl_opportunity_detail: {},
            complcl_investment_review: {},
            complcl_payment: {},
            complcl_exceptions: {},
            complcl_sampling: {},
            complcl_sampling_SSA: {},
            complcl_sampling_Solution: {},
            sampling_q: {},
            logs: {},
            gpp_valid: [],
            gpp_history: [],
            teams: [],
            statuses: [],
            substatuses: [],
            svistatuses: [],
            countriesAndImt: [],
            files: [],
            sampling: {},
            comments: {},
            calculation_logs: {},
            invoice_flags: {},
            sales_assist: {},
            ctl_so: {}
        };
        this.searchDropDownNames = {
            '': 'Unknown',
            'MGR': 'MGR',
            'FP-CN': 'Cust No.',
            'FP-BP': 'Acc Name',
            'FP-SN': 'Site No.',
            'FP-SO': 'S. Order',
            'CMR': 'CMR',
            'VCMR': 'Validation CMR',
            'AVCMR': 'Auto. Val. CMR',
            'GPP': 'MySA',
            'GPP-AP': 'GPP',
            'SC': 'Sales Connect',
            'SC-AP': 'Sal Con',
            'FP-V-CN': 'Cust No.',
            'FP-V-BP': 'Acc Name',
            'FP-V-SN': 'Site No.',
            'FP-V-SO': 'S. Order',
            'NC': 'AIW',
            'goe_data': "FindGOE",
            'GOE_DATA': "FindGOE",
            'GOE_VALID': "FindGOE",
            'GOE_VALID_DATA': "2ndGOE",
            'CMR_VALID_DATA': "2ndCMR",
            'dc_mysa': 'MySA',
            'dc_mysa_v4': 'MySA',
            'dc_v5': 'MySA',
            'dc_sc': 'Sales Connect',
            'MYSA_DUP': 'MySA',
            'SC_DUP': 'Sales Connect'
        };
        // Fills the topic - which will then fill all the fields in details
        this.clearTopic(undefined);
        this.visibleTabs = {};
        this.fpGovHostCodes = ['12', '13', '14', '15', '16', '17'];
        this.tabs = {
            // The list of tabs, that should be appeared
            list: [],
            // To identify which tab is active - and also to identify which edit tab to open
            activeTab: ''
        };
        //this.gov = {};
        //this.unkn = {};
        //this.resetEditable();
    }
    /**
     * Function called when topic is loaded/refreshed.  The reason is to
     * determine whether the sub-status is system-set or not which will then determine if the drop-down should be
     * visible at all.  This is a workaround that would not be needed if the sub-status field model was the status
     * object rather than the status description
     */
    TopicService.prototype.checkSubStatus = function () {
        var subStatus = this.config.getSubStatusBySubStatusNo2(this.topic.status.status_no, this.topic.status.sub_status_no);
        this.isSubSystemSet = !!subStatus && subStatus.system;
    };
    /**
     * Function to called if disbursement in an approval stage, ie: 2 or 5...purpose is to work out whether
     * the current user has authority to approve the current stage
     */
    TopicService.prototype.canApproveThisStage = function () {
        //First things first...the same user can't approve more than one stage...so if they have already approved during the process, do not allow
        if (angular.isDefined(this.topic.status.approvals.approvers) && this.topic.status.approvals.approvers.indexOf(this.env.user.email) > -1) {
            return false;
        }
        var appStage = this.config.getSubStatusBySubStatusNo2(this.topic.status.status_no, this.topic.status.sub_status_no);
        if (appStage.peer) {
            //If in a peer (non manager/team lead approval stage)
            if (appStage.bpso && this.env.user.access.bpsoAdmin) {
                //&& this.env.user.email !== this.topic.owner) {
                //If stage is BPSO Admin Peer AND user has that role AND user is not Assignee
                return true;
            }
            else if (!appStage.bpso && this.env.user.access.nonBpsoAdmin) {
                //If stage is Non-BPSO Admin Peer AND user has that role
                return true;
            }
        }
        else {
            //If in team lead/management approval stage
            if (appStage.bpso
                && this.env.user.access.bpsoApprover
                && this.config.isStageApprover(this.env.user.email, this.topic.status.status_no, this.topic.status.sub_status_no)) {
                //&& this.env.user.email !== this.topic.owner) {
                //If stage is BPSO Approver AND user has that role AND is listed as one of the approvers AND is not Assignee
                return true;
            }
            else if (!appStage.bpso
                && this.env.user.access.nonBpsoApprover
                && this.config.isStageApprover(this.env.user.email, this.topic.status.status_no, this.topic.status.sub_status_no)) {
                //If stage is Non-BPSO Approver AND user has that role AND is listed as one of the approvers
                return true;
            }
        }
        return false;
    };
    TopicService.prototype.compareDates = function (date1, date2) {
        var _MS_PER_DAY = 1000 * 60 * 60 * 24;
        var d1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
        var d2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
        var diff = Math.floor((d1 - d2) / _MS_PER_DAY);
        return diff;
    };
    /**
     * setActionButtons - Function to be called when the topic and everything has been loaded.  This runs
     * the actionStatus function against each user action in turn, setting true or false accordingly.  If all are
     * false the noneAvailable variable will be set to true and the action button will be disabled
     */
    TopicService.prototype.setActionButtons = function () {
        //If in the approval processes, check if the user is someone who can approve
        var canApprove = false;
        if ([2, 5].indexOf(this.topic.status.status_no) > -1) {
            canApprove = this.canApproveThisStage();
        }
        this.actions = {
            approve: this.actionStatus('approve', canApprove),
            cancelApproval: this.actionStatus('cancelApproval', canApprove),
            close: this.actionStatus('close', canApprove),
            createDispute: this.actionStatus('createDispute', canApprove),
            initiateValidation: this.actionStatus('initiateValidation', canApprove),
            refreshChecklists: this.actionStatus('refreshChecklists', canApprove),
            reject: this.actionStatus('reject', canApprove),
            rejectDis: this.actionStatus('rejectDis', canApprove),
            renotify: this.actionStatus('renotify', canApprove),
            resolveError: this.actionStatus('resolveError', canApprove),
            reverseApproval: this.actionStatus('reverseApproval', canApprove),
            rollbackStatus: this.actionStatus('rollbackStatus', canApprove),
            submitForApproval: this.actionStatus('submitForApproval', canApprove),
            viewDisputeList: this.actionStatus('viewDisputeList', canApprove),
            viewDisputes: this.actionStatus('viewDisputes', canApprove),
            changeInvReqFlag: this.actionStatus('changeInvReqFlag', canApprove),
            changeInvReceivedFlag: this.actionStatus('changeInvReceivedFlag', canApprove),
            //copyOppData: this.actionStatus('copyOppData', canApprove),
            submittedToAccountsFlag: this.actionStatus('submittedToAccountsFlag', canApprove),
            changeSalesAssist: this.actionStatus('changeSalesAssist', canApprove),
            updatePaymentDetailsStatus: this.actionStatus('updatePaymentDetailsStatus', canApprove),
            moveToPaidStatus: this.actionStatus('moveToPaidStatus', canApprove),
            overrideProspect: this.actionStatus('overrideProspect', canApprove),
            refreshSiteIds: this.actionStatus('refreshSiteIds', canApprove),
            updateCmrCdid: this.actionStatus('updateCmrCdid', canApprove),
            reAssignUser: this.actionStatus('reAssignUser', canApprove),
            embargoCheck: this.actionStatus('embargoCheck', canApprove),
            countryManualReview: this.actionStatus('countryManualReview', canApprove),
            crossBoarderEmea: this.actionStatus('crossBoarderEmea', canApprove),
            notificationPreview: this.actionStatus('notificationPreview', canApprove)
        };
        var nAvail = true;
        angular.forEach(this.actions, function (button) {
            if (button) {
                nAvail = false;
            }
        });
        this.actions.noneAvailable = nAvail;
    };
    ;
    TopicService.prototype.isAdminUser = function () {
        if (this.env.user.access.bpsoAdmin || this.env.user.access.nonBpsoAdmin) {
            return true;
        }
        return false;
    };
    TopicService.prototype.isReader = function () {
        if (this.env.user.access.reader) {
            return true;
        }
        return false;
    };
    /**
     * actionStatus - Function to determine whether the action buttons should be visible for the user.
     *                Assignee doesn't really mean much in terms of controlling who can access action buttons.
     *                Basically, if the user is able to access the document (controlled by country access) and they
     *                are not a READER, they may be able to click the buttons...
     * @param  {string} action:   string The action button in question
     * @return                    true if should be visible; else false
     */
    TopicService.prototype.actionStatus = function (action, canApprove) {
        var readerActions = ['viewDisputes', 'viewDisputeList'];
        if (this.isReader() && readerActions.indexOf(action) < 0) {
            return false;
        }
        // If no owner, only the Assign and viewDisputeList button should be available
        var noOwnerActions = ['reAssignUser', 'viewDisputeList'];
        if (!this.hasOwner() && noOwnerActions.indexOf(action) < 0) {
            return false;
        }
        if (action === 'submitForApproval') {
            // If no approval required, or it is and is complete
            if (!this.topic.status.approvals.approval_required || this.topic.status.approvals.complete) {
                return false;
            }
            if ([1, 4].indexOf(this.topic.status.status_no) === -1 || !this.isAdminUser()) {
                return false; //Not in Received or Validation status
            }
            //Only show if in stage 1 (and enabled for Pre-Approval) or stage 4 (with calcs started) and not an approver
            var preApp = this.config.hasPreApproval();
            if (((this.topic.status.status_no === 4 && angular.isDefined(this.topic.calculation)) || (this.topic.status.status_no === 1 && preApp))) {
                return true;
            }
        }
        else if (action === 'resolveError') {
            //Only show if user is an ADMIN and there are unresolved errors // Card 744 Domenico with Matt
            if (this.env.user.access.systemAdmin && angular.isDefined(this.topic.errors) && this.topic.errors.unresolved > 0) {
                return true;
            }
        }
        else if (action === 'renotify') {
            //Only show if in the middle of approval process...and is an approver (admin or approver role)
            if ([2, 5].indexOf(this.topic.status.status_no) > -1 && this.env.user.approver) {
                return true;
            }
        }
        else if (action === 'cancelApproval') {
            //Only show if in the middle of approval process and the user is NOT someone who can approve
            if ([2, 5].indexOf(this.topic.status.status_no) > -1 && !canApprove && !this.env.user.reader) {
                return true;
            }
        }
        else if (action === 'reverseApproval') {
            //Only show if in Eligibility or Validation process and enabled for Pre-approval, or in Approved status
            var preApp = this.config.hasPreApproval();
            if ((this.topic.status.status_no === 6 || ([3, 4].indexOf(this.topic.status.status_no) > -1 && preApp))
                && (this.isAdminUser() || this.env.user.systemAdmin)) {
                return true;
            }
        }
        else if (['approve', 'reject'].indexOf(action) > -1) {
            if ([2, 5].indexOf(this.topic.status.status_no) > -1 && canApprove) {
                return true; //Not in approval status
            }
        }
        else if (action === 'initiateValidation') {
            //Should only be visible in stage 3 Eligibility - if flow has the status.  Plus only if sub-status is Marked as Eligble(3) or Partially Eligible(4)
            // Not relevant for claims that do not have the Eligibility status since they will auto move to Validation upon Assignment
            if ([3].indexOf(this.topic.status.status_no) > -1 && [3, 4, 23, 28, 29, 32, 33].indexOf(this.topic.status.sub_status_no) > -1
                && this.isAdminUser()) {
                return true;
            }
        }
        else if (action === 'rejectDis') {
            //Should only be visible in stage 1 Received (if enabled for pre-approval),
            //stage 3 Eligibility, stage 4 Validation, stage 6 Approved
            var preApp = this.config.hasPreApproval();
            if (((this.topic.status.status_no === 1 && preApp)
                || [3, 4, 6].indexOf(this.topic.status.status_no) > -1)
                && this.isAdminUser()) {
                return true;
            }
        }
        else if (action === 'createDispute') {
            //Should only be visible in stage 7,8,9 (Paid, Rejected, Closed)...or stage 4 (Validation) but
            // in a Set-Aside status....and is not a dispute itself
            if (((this.topic.status.status_no === 4
                && [13, 15, 16, 17, 18, 19, 20, 21, 22, 24].indexOf(this.topic.status.sub_status_no) > -1)
                || [7, 8, 9].indexOf(this.topic.status.status_no) > -1)
                && this.isAdminUser()) {
                return true;
            }
        }
        else if (action === 'viewDisputeList') {
            //Only visible if a dispute...and topic has a dispute_details object...anyone can view
            if (angular.isDefined(this.topic.dispute_details)) {
                return true;
            }
        }
        else if (action === 'viewDisputes') {
            //Only visible if at least 1 dispute has been created...anyone can view
            if (angular.isDefined(this.topic.disputes) && this.topic.disputes.length > 0) {
                return true;
            }
        }
        else if (action === 'close') {
            //Should only be visible in stage 1 Received (if enabled for pre-approval),
            //stage 3 Eligibility, stage 4 Validation, stage 6 Approved
            var preApp = this.config.hasPreApproval();
            if (((this.topic.status.status_no === 1 && preApp)
                || [3, 4, 6].indexOf(this.topic.status.status_no) > -1)
                && this.isAdminUser()) {
                return true;
            }
        }
        else if (action === 'rollbackStatus') {
            //Only allow for System Admin...and only if sub-status is system-set OR if in Validation, Closed or Paid status where they could be rolled-back
            if ([2, 5].indexOf(this.topic.status.status_no) < 0
                && ([4, 7, 9].indexOf(this.topic.status.status_no) > -1 || this.config.isSystemStatus(this.topic.status.status_no, this.topic.status.sub_status_no)) && this.env.user.access.systemAdmin) {
                return true;
            }
        }
        else if (action === 'refreshChecklists') {
            //Only allow for System Admin...and only if in Elig,Validation or Approved statuses - if Closed/Rejected/Paid..allow for Sampling update
            if ([3, 4, 6, 7, 8, 9].indexOf(this.topic.status.status_no) > -1 && this.env.user.access.systemAdmin) {
                return true;
            }
        }
        else if (action === 'changeInvReqFlag') {
            if (this.topic.status.status_no === 4 &&
                [13, 15, 16, 17, 18, 19, 20, 21, 22].indexOf(this.topic.status.sub_status_no) > -1) {
                if (this.env.user.access.bpsoAdmin) {
                    return true;
                }
            }
        }
        else if (action === 'changeInvReceivedFlag') {
            if (this.topic.status.status_no === 4 &&
                [13, 15, 16, 17, 18, 19, 20, 21, 22].indexOf(this.topic.status.sub_status_no) > -1) {
                if (this.env.user.access.bpsoAdmin) {
                    return true;
                }
            }
        }
        else if (action === 'submittedToAccountsFlag') {
            if (this.topic.status.status_no === 4 && [13, 15, 16, 17, 18, 19, 20, 21, 22].indexOf(this.topic.status.sub_status_no) > -1) {
                if (this.env.user.access.bpsoAdmin) {
                    return true;
                }
            }
        }
        else if (action === 'changeSalesAssist') {
            if (this.env.user.access.systemAdmin) {
                return true;
            }
        }
        else if (action === 'embargoCheck') {
            return _.get(this, 'checksData.manualReview.history.isRCISCountry', false) && (this.env.user.access.systemAdmin || this.env.user.access.bpsoAdmin);
        }
        else if (action === 'countryManualReview') {
            return (_.get(this, 'checksData.manualReview.history.isChinaCountry', false) ||
                _.get(this, 'checksData.manualReview.history.isItalyCountryException', false) ||
                _.get(this, 'checksData.manualReview.history.isAsiaPacificCountryException', false)) ||
                _.get(this, 'checksData.manualReview.history.isKoreaCountryException', false) ||
                _.get(this, 'checksData.manualReview.history.isJapanCountryException', false) &&
                    (this.env.user.access.systemAdmin || this.env.user.access.bpsoAdmin);
        }
        else if (action === 'updatePaymentDetailsStatus') {
            if (this.env.user.access.systemAdmin) {
                if (this.topic.status.status_no === 7 || ([4, 6].indexOf(this.topic.status.status_no) > -1 && this.areCalcsStarted())) {
                    // const setAside: boolean = this.topic.calculation && this.topic.calculation.sapResult === 'Set Aside' ? true : false;
                    // if (!setAside) {
                    //     return true;
                    // }
                    return true;
                }
            }
        }
        else if (action === 'moveToPaidStatus') {
            if (this.env.user.access.bpsoAdmin) {
                var updateBundle = Object.assign({}, this.topic.calculation);
                if ((this.topic_ext.sub_status === 'Pending BPSO - Submit to Accounts Payable' ||
                    this.topic_ext.sub_status === 'Pending Accounts Payable') && updateBundle.goe === 'N') {
                    return true;
                }
            }
        }
        else if (action === 'updateCmrCdid') {
            var uiVersion = _.get(this, 'checksData.uiVersion', 1);
            var cmrNumber = _.get(this, 'checksData.inbound.inbound.incentiveInformation.incentiveDetail.incentiveCMRNumber', '');
            var generics = _.get(this, 'checksData.inbound.inbound.incentiveInformation.incentiveDetail.generics', []);
            var isDCID = generics.filter(function (genericObject) { return genericObject.name === 'domesticClientId' && genericObject.value; }).length > 0;
            var isSystem = this.env.user.access.systemAdmin;
            var isBPSO = this.env.user.access.bpsoAdmin;
            if (uiVersion >= this.OPP_VERSION_3 && (((!cmrNumber || !isDCID) && isBPSO) || isSystem)) {
                return true;
            }
        }
        else if (action === 'overrideProspect') {
            var uiVersion = _.get(this, 'checksData.uiVersion', 1);
            var cmrNumber = _.get(this, 'checksData.inbound.inbound.incentiveInformation.incentiveDetail.incentiveCMRNumber', '');
            if (cmrNumber.substr(0, 1) === "P" && uiVersion >= this.OPP_VERSION_3 && (this.env.user.access.systemAdmin || this.env.user.access.bpsoAdmin)) {
                return true;
            }
        }
        else if (action === 'reAssignUser') {
            if (this.env.user.access.bpsoAdmin || this.env.user.access.systemAdmin || this.env.user.access.nonBpsoAdmin) {
                return true;
            }
            return true;
        }
        else if (action === 'refreshSiteIds') {
            // Only show on eligibility and exclude "eligible" substatuses
            if ((this.env.user.access.bpsoAdmin || this.env.user.access.systemAdmin || this.env.user.access.nonBpsoAdmin) &&
                this.topic.version && this.topic.version >= this.OPP_VERSION_5 &&
                (this.topic.status.status_no < 4 && !([3, 4, 23, 28, 29, 32, 33].indexOf(this.topic.status.sub_status_no) > -1))) {
                return true;
            }
        }
        else if (action === 'crossBoarderEmea') {
            return (_.get(this, 'checksData.manualReview.history.isCrossBoarder', false) &&
                _.get(this, 'checksData.manualReview.history.isEmeaCountry', false) &&
                (this.env.user.access.systemAdmin || this.env.user.access.bpsoAdmin));
        }
        else if (action === 'notificationPreview') {
            if ((this.env.user.access.systemAdmin || this.env.user.access.bpsoAdmin || this.env.user.access.nonBpsoAdmin) &&
                _.get(this, 'topic.bpNotificationTemplateInfo.isTemplateExist', false)) {
                return true;
            }
        }
        // else if (action === 'copyOppData') {
        //     const isDispute: boolean = /-DIS:/.test(this.topic._id);
        //     // if role is admin and it's parent. Feature is not applicable to dev
        //     if (this.env.user.access.systemAdmin && !isDispute) {
        //         return true;
        //     }
        // }
        return false; ///set to true to see all buttons
    };
    /**
     * Function to determine if disbursement is in a Set Aside sub-status
     */
    TopicService.prototype.isSetAside = function () {
        var subby = this.config.getSubStatusBySubStatusNo2(this.topic.status.status_no, this.topic.status.sub_status_no);
        if (subby.txt.indexOf('Set Aside') > -1) {
            return true;
        }
        return false;
    };
    /**
     * Function to determine if the Disbursement is at the end of its life cycle, ie: Rejected, Paid or Closed
     */
    TopicService.prototype.isComplete = function () {
        if ([7, 8, 9].indexOf(this.topic.status.status_no) > -1) {
            return true;
        }
        return false;
    };
    /**
      resetEditable - Resets the editableComponents values to false, or removes them completely
    */
    TopicService.prototype.resetEditable = function () {
        // Decision if the template can be edited & if its currently in edit mode
        var _this = this;
        //These objects do not exist on the saved cloud document - they need to be added at initial load time
        var sections = ['eligibility', 'validation', 'sampling_SSA', 'mysa', 'sampling_Solution', 'payment', 'fcmr', 'fcmr_valid'];
        //Set the files and comments objects for each
        this.editableComponents = {};
        angular.forEach(sections, function (section) {
            _this.editableComponents['files$' + section] = { editable: false, editMode: false };
            _this.editableComponents['comments$' + section] = { editable: false, editMode: false };
        });
    };
    /**
      updateSocketStatus - Updates the socket status of editableComponents based on input or editable property
      @param {any} nestedArray:  Array of nested objects, whose edit options should be recalculated
      @returns void
    */
    TopicService.prototype.updateSocketStatus = function (nestedArray) {
        var _this = this;
        var currentStatus = this.connected ? '' : 'Disconnected';
        angular.forEach(nestedArray, function (prop) {
            if (_this.editableComponents[prop].editable) {
                _this.editableComponents[prop]['socket'] = currentStatus;
            }
            else if (_this.editableComponents[prop].locked) {
                _this.editableComponents[prop]['socket'] = 'Locked';
            }
            else {
                _this.editableComponents[prop]['socket'] = 'Not Editable';
            }
        });
    };
    /**
      updatePartialSocketStatus - If a update is performed this function identifies which object is beeing updated in editableComponents. If the socket property
      is empty then its updateable, if somethign is filled (upd - updating and waitng for response, dc - socket disconnected)
      @param {Array<string>} itemArray:       array of strings, which identify what object's socket property is changed
      @param {string} newValue:               value to update
      @returns boolean                        decides if hte object can be updated or not
    */
    TopicService.prototype.updatePartialSocketStatus = function (itemArray, newValue) {
        var _this = this;
        var canBeUpdated = true;
        angular.forEach(itemArray, function (value) {
            // socket item has to be defined, not 'dc' and not filled if you want to add a non empty string
            if (angular.isDefined(_this.editableComponents[value])) {
                if (_this.editableComponents[value]['socket'] === 'Locked' && _this.env.user.access.systemAdmin) {
                }
                else if ((!_this.editableComponents[value].editable) &&
                    ((_this.editableComponents[value]['socket'] === 'Disconnected') ||
                        (_this.editableComponents[value]['socket'] !== '' && newValue !== 'clear'))) {
                    canBeUpdated = false;
                }
            }
            else {
                canBeUpdated = false;
            }
        });
        if (canBeUpdated) {
            angular.forEach(itemArray, function (value) {
                if (_this.editableComponents[value]['socket'] !== 'Disconnected' && newValue === 'clear') {
                    newValue = '';
                }
                _this.editableComponents[value]['socket'] = newValue;
            });
            return true;
        }
        else {
            this.notify.error('You either do not have access, or are not permitted to make any updates at present');
            return false;
        }
    };
    /**
      clearTopic - Clears all the important properties of the topic. Calculates the browser random ID, calculates socket statuses
      @param {string} id:       id of the topic
    */
    TopicService.prototype.clearTopic = function (id) {
        // console.info('$topic (clearTopic) => clearing topic');
        if (angular.isUndefined(this.loaded)) {
            this.clearLoading();
        }
        this.loaded.topic = false;
        var array = new Uint32Array(2);
        this.topicBrowserID = window.crypto.getRandomValues(array)[0];
        this.reloadCheck = {
            topicBrowserID: this.topicBrowserID,
            id: id //Q unique ID
        };
        this.topic = angular.copy(this.topicObjTemplate);
        this.editArrays = {
            editableObjectArrayFalse: [],
            editableObjectArrayTrue: [],
            nonEditArray: [],
            nonEditArrayBrowser: [],
            lockedArray: [],
            editableComponentsArray: []
        };
        this.resetCompareGppData();
        this.topic_ext = {};
        this.decStatus = 'Unknown';
        this.temp = {
            mgr: {},
            cl: {},
            fp: {},
            gpp: {},
            cmr: {},
            cmr_valid_data: {},
            goe_data: {},
            sc: {},
            pw: {},
            bpims: {},
            dc: {},
            pd: {},
            complcl: {},
            sampling_q: {},
            logs: {},
            comments: {}
        };
        this.temp_ext = {};
        this.liveGpp = {};
        this.country = {};
        if (angular.isUndefined(this.loaded) || !this.loaded.userProfile) {
            this.resetEditable(); //initiate editablecomponents
            var propArray = [];
            for (var prop in this.editableComponents) {
                propArray.push(prop);
            }
            this.updateSocketStatus(propArray);
        }
        else {
            for (var prop in this.topic.editableComponents) {
                this.calculateAccess([prop], false);
            }
        }
    };
    /**
      clearLoading - clears the loading values
    */
    TopicService.prototype.clearLoading = function () {
        this.loaded = { config: false, topic: false, gpp_valid: false, gpp_elig: false, settings: false, program: false, userProfile: false };
    };
    /**
      fromConfig - Sends all the data from config
    */
    TopicService.prototype.fromConfig = function () {
        this.loaded.config = true;
        this.transformTopic();
    };
    /**
      fromConfigProgram - Called once the program profile has been retrieved and set - from site.body.component
    */
    TopicService.prototype.fromConfigProgram = function () {
        this.loaded.program = true;
        //this.setActionButtons(); //Make call on the hide/show for the action buttons
    };
    /**
      fromUserProfile - Check if the topic is loaded, if not, save the nested objects for later process
    */
    TopicService.prototype.fromUserProfile = function () {
        this.loaded.userProfile = true;
        if (!this.loaded.topic) {
            if (angular.isUndefined(this.processAccessLater)) {
                this.processAccessLater = [];
            }
            for (var prop in this.editArrays.editableComponentsArray) {
                this.processAccessLater.push(this.editArrays.editableComponentsArray[prop]);
            }
        }
        for (var prop in this.editArrays.editableComponentsArray) {
            this.calculateAccess([this.editArrays.editableComponentsArray[prop]], true);
        }
    };
    /**
      calculateAccess - Checks if the array of nested objects is editable or not
      @param {any} nestedObj:       nested object to check if editable
      @param {boolean} addObj:      if true, nested object that will be passed will be added into editableCompnents
    */
    TopicService.prototype.calculateAccess = function (nestedObj, addObj) {
        var _this = this;
        var nestedUpd = [];
        angular.forEach(nestedObj, function (nested) {
            if (angular.isDefined(_this.editableComponents[nested]) || addObj) {
                _this.editableComponents[nested] = {
                    editable: false,
                    editMode: false,
                    socket: ''
                };
                if (_this.editArrays.lockedArray.indexOf(nested) > -1) {
                    _this.editableComponents[nested].locked = true; //If is in the locked array, set as locked
                }
                else if (angular.isUndefined(_this.editArrays.nonEditArrayBrowser) || _this.editArrays.nonEditArrayBrowser.indexOf(nested) > -1
                    || _this.editArrays.nonEditArray.indexOf(nested) > -1) {
                }
                else if (_this.editArrays.editableObjectArrayFalse.indexOf(nested) > -1) {
                    //If if the editfalse array set accordingly
                    _this.editableComponents[nested].editable = true;
                    _this.editableComponents[nested].editMode = false;
                }
                else if (_this.editArrays.editableObjectArrayTrue.indexOf(nested) > -1) {
                    //If if the edittrue array set accordingly
                    _this.editableComponents[nested].editable = true;
                    _this.editableComponents[nested].editMode = true;
                }
                else {
                }
                nestedUpd.push(nested);
            }
        });
        //Call routine to set each editable object's socket status..ie: 'Not editable' etc
        this.updateSocketStatus(nestedUpd);
    };
    /**
      updateEditOptions - updates editableComponentsArray based on the server editOptions & at the end calculates the access.
      @param {any}          data:      Contains the editOption object, that is sent from the server(has the edit, non-edit, locked objects)
      @param {string}    program:      program of the opened oppty
    */
    TopicService.prototype.updateEditOptions = function (data, program) {
        var _this = this;
        this.resetEditable(); //Wipe....so it can be refreshed with the values from the server (otherwise items NOT pulled back from the server remain editable)
        this.editArrays.editableObjectArrayFalse = data.editableObjectArrayFalse;
        this.editArrays.editableObjectArrayTrue = data.editableObjectArrayTrue;
        this.editArrays.nonEditArray = data.nonEditArray;
        this.editArrays.lockedArray = data.lockedArray;
        this.setTabList(data.openableTabs, program);
        this.editArrays.editableComponentsArray = [];
        angular.forEach(this.editArrays.editableObjectArrayFalse, function (nested) {
            _this.editArrays.editableComponentsArray.push(nested);
        });
        angular.forEach(this.editArrays.editableObjectArrayTrue, function (nested) {
            _this.editArrays.editableComponentsArray.push(nested);
        });
        angular.forEach(this.editArrays.nonEditArray, function (nested) {
            _this.editArrays.editableComponentsArray.push(nested);
        });
        angular.forEach(this.editArrays.lockedArray, function (nested) {
            _this.editArrays.editableComponentsArray.push(nested);
        });
        this.calculateAccess(this.editArrays.editableComponentsArray, true);
    };
    /**
      fromSettings - Sends all the data from config
    */
    TopicService.prototype.fromSettings = function () {
        this.loaded.settings = true;
        this.setCountry();
    };
    /**
      sameRequest - Returns true if the same opp number is beeing selected again
      @param {string} identifier:   identifier of the opened screen
      @returns {boolean}            calls at the end updateServerTopic - that sends the socket to the server
    */
    TopicService.prototype.sameRequest = function (identifier) {
        return (this.topic.identifier === identifier) ? true : false;
    };
    TopicService.prototype.setCountry = function () {
        if ((this.loaded.settings || this.settings.loaded) && this.loaded.topic) {
            this.country = this.settings.calcCountryObj(this.topic.gpp[0].acctctry);
        }
    };
    TopicService.prototype.topicLoaded = function () {
        this.loaded.topic = true;
    };
    /** Updates every property in the topic object one by one
        @param {any} data:   Passes the object from server into topic without any calculation
    */
    TopicService.prototype.updateTopicWithoutCalc = function (data) {
        for (var prop in data) {
            if (!data.hasOwnProperty(prop)) {
                continue;
            }
            ;
            this.topic[prop] = data[prop];
            if (prop === 'gpp_live') {
                this.calculateGppDifference('gpp_live', 'gpp');
            }
        }
    };
    /**
      calculateGppDifference - calculates the difference in the GPP array objects and sets true for every property in compareGpp,
        where the value is identical. If difference, its marked as red. If row ID missing, put it into another gppMissing variable
      @param {string} original:   string name of the to be compared gpp object
      @param {string} difference:   string name of the to be display red items in the gpp object
      @returns void
    */
    TopicService.prototype.calculateGppDifference = function (original, difference) {
        var _this = this;
        if (angular.isUndefined(this.compareGpp[difference])) {
            this.compareGpp[difference] = {};
        }
        angular.forEach(this.topic[difference], function (diffItem) {
            if (angular.isUndefined(diffItem.ods_mismatch)) {
                _this.compareGpp.gppSection.ods.message = 'ODS check not performed';
            }
            else if (diffItem.ods_mismatch) {
                _this.compareGpp.gppSection.ods.status = true;
            }
            _this.compareGpp[difference][diffItem.row_id] = { found: false };
        });
        angular.forEach(this.topic[original], function (origItem) {
            var foundLine = false;
            angular.forEach(_this.topic[difference], function (diffItem) {
                if (angular.isDefined(origItem.row_id) && angular.isDefined(diffItem.row_id) && origItem.row_id === diffItem.row_id) {
                    foundLine = true;
                    _this.compareGpp[difference][diffItem.row_id].found = true;
                    for (var prop in diffItem) {
                        if (diffItem[prop] === origItem[prop]) {
                            _this.compareGpp[difference][diffItem.row_id][prop] = true;
                        }
                        else {
                            // To display warning sign if something is missing there
                            if (_this.compareGpp.gppSection.bf.variables.indexOf(prop) > -1) {
                                _this.compareGpp.gppSection.bf.status = true;
                            }
                            else if (_this.compareGpp.gppSection.or.variables.indexOf(prop) > -1) {
                                _this.compareGpp.gppSection.or.status = true;
                            }
                            else if (_this.compareGpp.gppSection.svi.variables.indexOf(prop) > -1) {
                                _this.compareGpp.gppSection.svi.status = true;
                            }
                            else if (_this.compareGpp.gppSection.ci.variables.indexOf(prop) > -1) {
                                _this.compareGpp.gppSection.ci.status = true;
                            }
                        }
                    }
                }
            });
            if (!foundLine) {
                _this.compareGpp.gppSection.bf.status = true;
                //this.compareGpp.gppSection.st.status = true;
                _this.compareGpp.gppSection.or.status = true;
                _this.compareGpp.gppSection.svi.status = true;
                _this.compareGpp.gppSection.ci.status = true;
                _this.compareGpp[difference + 'Missing'].push(origItem);
            }
        });
    };
    /**
      lockCheck - Checks if the updated objects in topic are locked or not.
      @param {Array<string>} propArray:   array contains objects, that are beeing updated in topic
    */
    /*lockCheck(propArray: any) {
        let lockCheckArray = ['cmr', 'mgr', 'fastpass', 'dc', 'complcl2', 'complcl3'];
        angular.forEach(lockCheckArray, (component) => {
            if (propArray.indexOf(component) > -1) {
                if (angular.isDefined(this.topic[component].locked) && this.topic[component].locked) {
                    this.editArrays.nonEditArrayBrowser.push(component);
                };
            }
        });
    }*/
    /** Updates every property in the topic object one by one and preforms calculations
     * @param {any}                        data:   data to be updated into the topic.
     * @param {boolean}                     sub:   true = updates topic with 10k$ code, false = it'll copy over the variables into topic
     * @param {Array<string>} updateEditObjects:   true = will recalculate also edit options, false= edit options recalculation is ignored
     * @returns void
     */
    TopicService.prototype.updateTopic = function (data, sub, updateEditObjects) {
        var _this = this;
        //console.info('$topic (updateTopic) => data: ', data, 'sub: ', sub, 'eo: ', updateEditObjects);
        var propArray = [];
        if (sub) {
            for (var prop in data) {
                var topicUpd = this.topic; //reset topic
                var varName = prop.split('.');
                propArray.push(varName[0]);
                var val = data[prop];
                //Ensure the prop exists - Added by Matt on 18th May 2017 since there are several scenarios
                //where the cloudantmodel is not up-to-date and valid objects do not exist on the topic...this
                //resylts in this code failing and not being able to refresh the browser content correctly
                if (angular.isUndefined(topicUpd[varName[0]])) {
                    topicUpd[varName[0]] = {};
                }
                //topicUpd = topicUpd[varName.shift()];
                // Getting to the location of the update object
                while (varName.length > 1) {
                    topicUpd = topicUpd[varName.shift()];
                }
                if (angular.isUndefined(topicUpd)) {
                    // In case the updated object is undefined, take the whole nested object content
                    this.updateServerTopic('getPartialCouchObj', { id: this.topic._id, data: {}, type: [varName[0]] }, false);
                }
                // Perform update based on type of update
                if (val.add) {
                    topicUpd[varName.shift()] = val.data;
                }
                else if (val.push) {
                    var dot = varName.shift();
                    if (!_.isArray(topicUpd[dot])) {
                        topicUpd[dot] = [];
                    }
                    for (var p in val.data) {
                        topicUpd[dot].push(val.data[p]);
                    }
                }
                else if (val.clearArray) {
                    var tempObj = varName.shift();
                    topicUpd[tempObj] = [];
                }
                else if (val.delete) {
                    delete topicUpd[varName.shift()];
                }
            }
        }
        else {
            for (var prop in data) {
                if (!data.hasOwnProperty(prop)) {
                    continue;
                }
                ;
                propArray.push(prop);
                this.topic[prop] = data[prop];
            }
        }
        if (propArray.length > 0) {
            if (updateEditObjects.length > 0) {
                this.calculateAccess(updateEditObjects, true);
            }
            else {
                this.calculateAccess(propArray, true);
            }
            this.topicLoaded();
        }
        if (propArray.indexOf('status') > -1 || propArray.indexOf('files') > -1) {
            this.transformTopic();
            //Make call on the hide/show for the action buttons...moved from socket listener fromConfigProgram()
            // since the settings HAVE to be loaded before the topic so need to wait until topic is loaded.  This function
            // needs both settings and topic to be loaded before firing
            this.setActionButtons();
        }
        var govItems = [];
        if (propArray.indexOf('complete') > -1 && angular.isDefined(this.topic.complete.errorsArray)) {
            this.topic.complete.errorsArray.all = [];
            var table_1 = [];
            for (var prop_1 in this.topic.complete.errorsArray) {
                // filter out errors from inner 2 goe check in validation - to exclude double errors on top level
                if (angular.isArray(this.topic.complete.errorsArray[prop_1]) &&
                    !['goePick_valid', 'complcl_validation'].includes(prop_1)) {
                    angular.forEach(this.topic.complete.errorsArray[prop_1], function (tableItem) {
                        table_1.push(tableItem);
                    });
                }
            }
            this.topic.complete.errorsArray.all = table_1;
        }
        if (propArray.indexOf('cmr_valid') > -1) {
            govItems.push('cmr_valid');
        }
        if (propArray.indexOf('cmr') > -1) {
            govItems.push('cmr');
        }
        if (propArray.indexOf('mgr') > -1) {
            govItems.push('mgr');
        }
        if (propArray.indexOf('fastpass') > -1) {
            govItems.push('fastpass');
        }
        if (propArray.indexOf('fastpass_valid') > -1) {
            govItems.push('fastpass_valid');
        }
        if (govItems.length > 0) {
            this.calcGovItems(govItems);
        }
        if (propArray.indexOf('gpp') > -1) {
            this.setTempFromTopicPart('gpp');
        }
        if (propArray.indexOf('elig_dec') > -1) {
            if (this.topic.elig_dec.eligibilityDecision === EligibilityDecision.FULLY_ELIGIBLE) {
                this.decStatus = 'Marked as Eligible';
            }
            else if (this.topic.elig_dec.eligibilityDecision === EligibilityDecision.PARTIALLY_ELIGIBLE) {
                this.decStatus = 'Marked as Partially Eligible';
            }
            else if (this.topic.elig_dec.eligibilityDecision === EligibilityDecision.SOLUTION_ONLY) {
                this.decStatus = 'Marked as Eligible - Solution Only';
            }
            else if (this.topic.elig_dec.eligibilityDecision === EligibilityDecision.REJECTED) {
                this.decStatus = 'Eligibility Rejected';
            }
            else if (this.topic.elig_dec.eligibilityDecision === EligibilityDecision.SOLUTION_AND_SPECIAL_BID_ONLY) {
                this.decStatus = 'Change Sub-Status to Marked as Eligible - Solution and Special Bid Only';
            }
            else if (this.topic.elig_dec.eligibilityDecision === EligibilityDecision.SPECIAL_BID_ONLY) {
                this.decStatus = 'Change Sub-Status to Marked as Eligible - Special Bid Only';
            }
        }
        this.setTempFromTopicPart('header_data');
        var countryArray = ['gpp'];
        angular.forEach(countryArray, function (component) {
            if (propArray.indexOf(component) > -1) {
                _this.setCountry();
            }
        });
        //Once the topic is loaded, check if the Program Profile is already loaded
        if (propArray.length > 0) {
            this.checkProgramProfile();
        }
        if (updateEditObjects) {
            this.$rootScope.$broadcast('broadcast:topicUpdated', propArray); // $rootScope.$on
        }
        propArray = [];
        //this.loaded.topic = true;
    };
    /**
     * checkProgramProfile - Function to check if the Program Profile needs to be loaded.  If already loaded
     * a check will be made to compare the program key of the current topic and the profile loaded.  If they
     * don't match, ie: user exits one Disbursement and enters another, the call will be made to get it
     *
     */
    TopicService.prototype.checkProgramProfile = function () {
        if (this.config.proProfileLoaded) {
            //If so, get the current program key from the topic
            var currPPKey = this.topic.country + this.topic.program + this.topic.bp_type +
                this.topic.onshore_offshore;
            //And the key of the profile loaded
            var profKey = this.config.proProfile.country + this.config.proProfile.program +
                this.config.proProfile.bp_type + this.config.proProfile.onshore_offshore;
            //check brands
            var brandMatch = false;
            if (this.topic.brands.indexOf(this.config.proProfile.brand) > -1) {
                brandMatch = true;
            }
            //if they don't match...
            if (currPPKey !== profKey || !brandMatch) {
                this.config.getProgramProfile(this.topic); //make the call to get it
            }
        }
        else {
            this.config.getProgramProfile(this.topic); //make the call to get it
        }
    };
    TopicService.prototype.setLiveGpp = function (data) {
        this.liveGpp = data;
    };
    TopicService.prototype.setTopic = function (data) {
        this.topic = data;
    };
    TopicService.prototype.getTopic = function () {
        return this.topic;
    };
    // Calulates if items in the table have the government flag set to Y.. its ugly now, but once we get more data sources, this will
    // be overwritten into a general function
    TopicService.prototype.calcGovItems = function (govItems) {
        var _this = this;
        angular.forEach(govItems, function (govItem) {
            var objectName = govItem;
            // Check if its a object and if its not undefined and has at least 1 result
            if (angular.isDefined(_this.topic[objectName]) && angular.isDefined(_this.topic[objectName].results) && angular.isArray(_this.topic[objectName].results)) {
                _this.topic[objectName].govs = -1;
                _this.topic[objectName].unkn = -1;
                if (_this.topic[objectName].results.length > 0) {
                    _this.topic[objectName].govs = 0;
                    _this.topic[objectName].unkn = 0;
                    angular.forEach(_this.topic[objectName].results, function (tableRow) {
                        if (angular.isDefined(tableRow.govs) && tableRow.govs > -1) {
                            _this.topic[objectName].govs += tableRow.govs;
                            _this.topic[objectName].unkn += tableRow.unkn;
                        } /*else {
                  angular.forEach(tableRow.table, (item) => {
                    // Insert here comparison if needed
                  });
                }*/
                    });
                }
            }
            else {
                _this.topic[objectName] = {};
                _this.topic[objectName].govs = -1;
                _this.topic[objectName].unkn = -1;
                _this.topic[objectName].results = [];
            }
        });
    };
    // transforms the topic status data from id's to description
    TopicService.prototype.transformTopic = function () {
        var _this = this;
        if (this.loaded.config && this.loaded.topic && this.loaded.userProfile) {
            //Just to copy into the temp folder the status
            this.temp['status'] = angular.copy(this.topic.status);
            this.setTempFromTopicPart('status');
            var tempTopic = {};
            this.topic_ext = {};
            angular.copy(this.topic, tempTopic);
            var tempStatus = { status: '', sub_status: '', status_array: [], problem: true };
            //Loops through available statuses and if the status is found looop through substatuses
            //if (!angular.isUndefined(this.topic.status.status_no) && !angular.isUndefined(this.config.tempData)) {
            if (!angular.isUndefined(this.topic.status.status_no) && !angular.isUndefined(this.settings.status_cfg)) {
                //angular.forEach(this.config.tempData.rows, (status) => {
                angular.forEach(this.settings.status_cfg, function (status) {
                    if (status.no === _this.topic.status.status_no) {
                        tempStatus.status = status.txt;
                        angular.forEach(status.subs, function (sub_status) {
                            tempStatus.status_array.push({ no: sub_status.no, txt: sub_status.txt, active: angular.isUndefined(sub_status.active) ? true : sub_status.active, system: angular.isDefined(sub_status.system) ? sub_status.system : false });
                            // status & substatus is found convert it
                            if (sub_status.no === _this.topic.status.sub_status_no) {
                                tempStatus.sub_status = sub_status.txt;
                                tempStatus.problem = false;
                            }
                        });
                    }
                });
                this.topic_ext = tempStatus;
            }
            else {
                console.info('could not load status: ' + this.topic.status.status_no + ' - ' + this.settings.status_cfg);
            }
            this.topic_ext.attachments = this.topic.files.map(function (file) { return file.name; });
            angular.copy(this.topic_ext, this.temp_ext);
        }
    };
    // translates status description into id values
    TopicService.prototype.detransform = function (obj) {
        var _this = this;
        var obj_ext = obj + '_ext';
        if (this.loaded.config && this.loaded.topic && this.loaded.userProfile) {
            //if (!angular.isUndefined(this[obj_ext].status) && !angular.isUndefined(this.config.tempData)) {
            if (!angular.isUndefined(this[obj_ext].status) && !angular.isUndefined(this.settings.status_cfg)) {
                //angular.forEach(this.config.tempData.rows, (status) => {
                angular.forEach(this.settings.status_cfg, function (status) {
                    if (status.txt === _this[obj_ext].status) {
                        _this[obj].status.status_no = status.no;
                        angular.forEach(status.subs, function (sub_status) {
                            // status & substatus is found convert it
                            if (sub_status.txt === _this[obj_ext].sub_status) {
                                _this[obj].status.sub_status_no = sub_status.no;
                            }
                        });
                    }
                });
            }
        }
    };
    /** diff- calculate the difference between 2 objects. This will keep only those objects, that are the temp difference vs topic content
     * @param {any}          a: temp object
     * @param {any}          b: topic object
     * @param {any} reversible: for now always false / probably not needed
     */
    TopicService.prototype.diff = function (a, b, reversible) {
        var r = {};
        this.deepDiff(a, b, r, reversible);
        if (reversible) {
            this.deepDiff(b, a, r, reversible);
        }
        return r;
    };
    // needed for the diff functions
    /** deepDiff shows difference also when object is undefined
     * @param {any}          a: temp object
     * @param {any}          b: topic object
     * @param {any}          r: result -the difference in object
     * @param {any} reversible: for now always false / probably not needed
     */
    TopicService.prototype.deepDiff = function (a, b, r, reversible) {
        var _this = this;
        _.each(a, function (v, k) {
            //Ivan This ensures, that also undefined objects will be displayed in delta
            if (angular.isUndefined(b)) {
                return r[k] = v;
            }
            if (angular.isUndefined(r) || angular.isUndefined(a)) {
                return;
            }
            // already checked this or equal...
            if (r.hasOwnProperty(k) || b[k] === v) {
                return;
            }
            // but what if it returns an empty object? still attach?
            var val = _.isObject(v) ? _this.diff(v, b[k], reversible) : v;
            if (!_.isObject(val) || _.keys(val).length > 0) {
                r[k] = val;
            }
        });
    };
    ;
    /** diff_withPath - Translates the difference object into a dot separated object
     * @param {any}    a: the difference object (its does not have string paths)
     * @param {any} path: the starting string path
     * @param {any}    r: starting result object
     */
    TopicService.prototype.diff_withPath = function (a, path, r) {
        this.deepDiff_withPath(a, path, r);
        return r;
    };
    /** deepDiff_withPath - Converts the difference object to dot separated objects - It does not work 100%, therefore in same cases you need stop
     *      the whole comparison and get only a part of the diff object
     * @param {any}    a: the difference object (its does not have string paths)
     * @param {any} path: the starting string path
     * @param {any}    r: starting result object
     */
    TopicService.prototype.deepDiff_withPath = function (a, path, r) {
        var _this = this;
        // Push the array for the whole object, if its the lower mentioned object
        if (path == 'gpp_history') {
            for (var prop in a) {
                if (!a.hasOwnProperty(prop)) {
                    continue;
                }
                ;
                if (angular.isUndefined(r[path])) {
                    r[path] = {};
                }
                ;
                if (angular.isUndefined(r[path]['data'])) {
                    r[path] = { data: [], push: true };
                }
                r[path]['data'].push(a[prop]);
            }
            return r;
        }
        //Ivan This ensures, that also undefined objects will be displayed in delta (at least once nested)
        _.each(a, function (v, k) {
            if (path + '.' + k === 'status.history' || path === 'comments') {
                for (var prop in v) {
                    if (!v.hasOwnProperty(prop)) {
                        continue;
                    }
                    ;
                    if (angular.isUndefined(r[path + '.' + k])) {
                        r[path + '.' + k] = {};
                    }
                    ;
                    if (angular.isUndefined(r[path + '.' + k]['data'])) {
                        r[path + '.' + k] = { data: [], push: true };
                    }
                    r[path + '.' + k]['data'].push(v[prop]);
                }
                return r;
            }
            if (path + '.' + k === 'status.cycle_times') {
                var itemToBeAdded = -1;
                var tempV = {};
                var toBeUpdItem = '';
                for (var toFindArrayObj in v) {
                    for (var updItemName in v[toFindArrayObj]) {
                        toBeUpdItem = updItemName;
                    }
                }
                for (var l = 0; l < _this.topic.status.cycle_times.length; l++) {
                    for (var ctProp in _this.topic.status.cycle_times[l]) {
                        if (toBeUpdItem === ctProp) {
                            itemToBeAdded = l;
                            tempV = _this.topic.status.cycle_times[l];
                        }
                    }
                    ;
                }
                ;
                if (itemToBeAdded > -1) {
                    r[path + '.' + k + '.' + itemToBeAdded] = { add: true, data: tempV };
                    return r;
                }
                else {
                    r[path + '.' + k] = { push: true, data: v };
                    return r;
                }
            }
            // but what if it returns an empty object? still attach?
            if (_.isObject(v) || _.isArray(v)) {
                r = _this.diff_withPath(v, path + '.' + k, r);
            }
            else if (!_.isObject(v) || _.keys(v).length > 0) {
                r[path + '.' + k] = { add: true, data: v };
                return r;
            }
            else {
                return r;
            }
        });
    };
    ;
    /** sendForUpdate - Prepares the object, that will be later on sent into server for update - handled only for status change
     * @param {string[]}    propertyNames: Array of strings that we plan to update
     * @param {string}      action:
     * @param {string}    comments:
     * @param {boolean}    partial: whatever was updated will be sent back & updated in topic
     */
    TopicService.prototype.sendForUpdate = function (propertyNames, action, comments, partial) {
        var _this = this;
        var tempDataArray = { id: this.topic._id, data: {}, type: [], action: action };
        if (propertyNames.indexOf('status') > -1) {
            this.detransform('temp');
            this.temp.status = this.status.statusChange(this.temp.status, this.topic.status, action, comments);
        }
        if (propertyNames.indexOf('sales_assist') > -1) {
            if (this.temp_ext.sales_assist) {
                this.temp.sales_assist = { type: this.temp_ext.sales_assist };
            }
        }
        var objPath = {};
        propertyNames.forEach(function (prop) {
            objPath = _.merge(objPath, _this.differenceByPath(prop));
            switch (prop) {
                case 'status':
                    tempDataArray[prop] = { id: _this.getId(_this.topic._id), opp: _this.topic.opp, status: _this.temp.status.status_no, subStatus: _this.temp.status.sub_status_no };
                    break;
                case 'sales_assist':
                    tempDataArray[prop] = _this.temp[prop];
                    break;
            }
            tempDataArray.type.push(prop);
        });
        tempDataArray.data = objPath;
        //if status change, then send also the DB2 update
        this.updateServerTopic('updateStatus', tempDataArray, partial);
    };
    TopicService.prototype.differenceByPath = function (propertyName) {
        var objDiff = {};
        objDiff[propertyName] = this.diff(this.temp[propertyName], this.topic[propertyName], false);
        return this.diff_withPath(objDiff[propertyName], propertyName, {});
    };
    /** sendForUpdateFiles - Prepares the object, that will be later on sent into server for update - handled only for files
     * @param {string}        comp: component to which the file belongs
     * @param {boolean}    partial: whatever was updated will be sent back & updated in topic
     */
    TopicService.prototype.sendForUpdateFiles = function (comp, partial) {
        var section = comp.replace('files$', '');
        //this.topic.sendForUpdateGeneral(this.updateArray, true);
        var filesData = [];
        angular.forEach(this.temp.files, function (file) {
            if (file.modified && file.type === section ||
                (section === 'sampling_SSA' && file.type === 'sampling')) {
                filesData.push({ name: file.name, comment: file.comment });
            }
        });
        var tempDataArray = {
            filesData: filesData,
            //id: this.topic.opp,
            id: this.topic._id,
            type: ['files$' + section]
        };
        if (filesData.length > 0) {
            this.updateServerTopic('updateFileNested', tempDataArray, partial);
        }
        else {
            this.cancelEdit(comp);
            this.calculateAccess([comp], false);
        }
    };
    ;
    /**sendForUpdateGeneral - Prepares the object, that will be later on sent into server for update
     * @param {any}          objectArray:     array of objects, that should be updated when we receive response
     * @param {boolean}          partial:     whatever was updated will be sent back & updated in topic
     * @param {boolean}   getEditOptions:     true = on respones the edit options will be recalculated, false = edit options recalculations ignored
     * @returns void             calls at the end updateServerTopic - that sends the socket to the server
     *
    */
    TopicService.prototype.sendForUpdateGeneral = function (objectArray, partial, getEditOptions, check) {
        var _this = this;
        var tempDataArray = { id: this.topic._id, data: {}, type: objectArray, getEditOptions: (getEditOptions ? true : undefined) };
        var objDiff = {};
        this.detransform('temp');
        var objPath = {};
        var statusUpdate = false;
        //this.temp.status = this.status.subStatusChange(this.temp.status);
        angular.forEach(objectArray, function (propWhole) {
            var propSplitted = propWhole.split('$');
            var prop = propSplitted[0];
            if (prop === 'gpp_valid') {
                objPath[prop] = { data: _this.temp[prop], add: true };
            }
            else {
                objDiff[prop] = _this.diff(_this.temp[prop], _this.topic[prop], false);
                var diffObj = _this.diff_withPath(objDiff[prop], prop, {});
                for (var attrname in diffObj) {
                    objPath[attrname] = diffObj[attrname];
                }
                ;
            }
            //objDiff[prop] =  this.diff2(this.temp[prop], this.topic[prop]);
        });
        tempDataArray.data = objPath;
        //if status change, then send also the DB2 update
        this.updateServerTopic('couchUpdate', tempDataArray, partial, check);
    };
    //sendCommentForUpdateGeneral- preps comment, calls updateServerTopic
    TopicService.prototype.sendCommentForUpdateGeneral = function (objectArray, partial, getEditOptions, check) {
        var _this = this;
        var tempDataArray = { id: this.topic._id, data: {}, type: objectArray, getEditOptions: (getEditOptions ? true : undefined) };
        var objDiff = {};
        this.detransform('temp');
        var objPath = {};
        angular.forEach(objectArray, function (propWhole) {
            var propSplitted = propWhole.split('$');
            var prop = propSplitted[0];
            objDiff[prop] = _this.diff(_this.temp[prop], _this.topic[prop], false);
            var diffObj = _this.diff_withPath(objDiff[prop], prop, {});
            for (var attrname in diffObj) {
                objPath[attrname] = diffObj[attrname];
            }
            ;
        });
        tempDataArray.data = objPath;
        this.updateServerTopic('updateCoreComments', tempDataArray, partial, check);
    };
    ;
    /** updateServerTopic - Sends the prepared object for updating couch
     * @param {string}    source:       which function to call in config/config eg. couchUpdate, updateStatus
     * @param {any}       upData:       consists of id (DMT-<opp>), type (array of objects, that were updated),
     * @param {boolean}  partial:     whatever was updated will be sent back & updated in topic
     * @returns void       sends a socket with the data to be updated
     */
    TopicService.prototype.updateServerTopic = function (source, upData, partial, check) {
        if (angular.isDefined(upData)) {
            if (this.isEmptyObject(upData.data)) {
                this.calculateAccess(upData.type, false);
                this.notify.error('No update was detected - Save Cancelled.');
                console.info('No update was detected - Save Cancelled.', upData.type);
            }
            else {
                for (var prop in upData.data) {
                    if (prop.includes('$$hashKey')) {
                        delete upData.data[prop];
                    }
                }
                this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        bID: this.topicBrowserID,
                        data: upData,
                        function: source,
                        partial: partial,
                        script: 'config/config',
                        token: this.env.user.token,
                        check: check
                    }
                });
            }
        }
        else {
            this.notify.error('Unable to update, section not defined');
            console.info('Unable to update, section not defined', upData);
        }
    };
    TopicService.prototype.updateChecksResults = function (upData) {
        if (angular.isDefined(upData)) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    bID: this.topicBrowserID,
                    data: upData,
                    function: 'updateInboundCMR',
                    script: '/detail/eligibility/eligibility',
                    token: this.env.user.token
                }
            });
        }
        else {
            this.notify.error('Unable to update checks results, data not defined');
        }
    };
    TopicService.prototype.remapAllChecks = function (data) {
        if (angular.isDefined(data)) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    bID: this.topicBrowserID,
                    data: data,
                    function: 'remapEmbargoChecks',
                    script: '/detail/eligibility/eligibility',
                    token: this.env.user.token
                }
            });
        }
        else {
            this.notify.error('Unable to remap checks - data not defined');
        }
    };
    TopicService.prototype.confirmCrossBoardEligibility = function (data) {
        if (angular.isDefined(data)) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    bID: this.topicBrowserID,
                    data: data,
                    function: 'confirmCrossBoardEligibility',
                    script: '/detail/eligibility/eligibility',
                    token: this.env.user.token
                }
            });
        }
        else {
            this.notify.error('Unable to confirm Cross Board - data not defined');
        }
    };
    TopicService.prototype.loadNotificationPreview = function (data) {
        if (angular.isDefined(data)) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    bID: this.topicBrowserID,
                    data: data,
                    function: 'loadNotification',
                    script: '/detail/eligibility/eligibility',
                    token: this.env.user.token
                }
            });
        }
        else {
            this.notify.error('Unable to load notification - data not defined');
        }
    };
    TopicService.prototype.sendNotification = function (data) {
        if (angular.isDefined(data)) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    bID: this.topicBrowserID,
                    data: data,
                    function: 'sendNotification',
                    script: '/detail/eligibility/eligibility',
                    token: this.env.user.token
                }
            });
        }
        else {
            this.notify.error('Unable to send notification - data not defined');
        }
    };
    TopicService.prototype.extractNotifications = function (data) {
        if (angular.isDefined(data)) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    bID: this.topicBrowserID,
                    data: data,
                    function: 'extractOpportunityNotifications',
                    script: '/detail/eligibility/eligibility',
                    token: this.env.user.token
                }
            });
        }
        else {
            this.notify.error('Unable to extract notification - data not defined');
        }
    };
    TopicService.prototype.isEmptyObject = function (obj) {
        if (angular.isUndefined(obj)) {
            return false;
        }
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop) && prop.indexOf('$$hashKey') === -1) {
                return false;
            }
        }
        return true;
    };
    TopicService.prototype.loopAndAssignObject = function (objectArray) {
        for (var prop in objectArray) {
            if (!objectArray.hasOwnProperty(prop)) {
                continue;
            }
            ;
            this.topic[prop] = objectArray[prop];
        }
    };
    /** setTempFromTopic - copies whole topic into temp
    */
    TopicService.prototype.setTempFromTopic = function () {
        this.temp = angular.copy(this.topic);
        //this.temp = this.topic;
    };
    /** setTempFromTopic - copies whole temp into topic
    */
    TopicService.prototype.setTopicFromTemp = function () {
        this.topic = angular.copy(this.temp);
        //this.topic = this.temp;
    };
    /** setTempFromTopicPart - Change the edit mode to true of the component & copy from topic to temp
     * @param {string}    obj:   object we want copy from topic to temp
     */
    TopicService.prototype.setTempFromCalculationV2 = function () {
        if (angular.isDefined(this.editableComponents['calculation']) && this.editableComponents['calculation'].editable) {
            this.temp['calculation'] = angular.copy(this['calculation']);
            return this.editableComponents['calculation'].editMode = true;
        }
        else {
            //alert('You are not authorized to modify ' + obj);
            return this.editableComponents['calculation'].editMode = false;
        }
    };
    /** setTempFromTopicPart - Change the edit mode to true of the component & copy from topic to temp
     * @param {string}    obj:   object we want copy from topic to temp
     */
    TopicService.prototype.setTempFromTopicPart = function (obj) {
        if (angular.isDefined(this.editableComponents[obj]) && this.editableComponents[obj].editable) {
            var objArray = obj.split('$');
            if (objArray.length === 1) {
                this.temp[obj] = angular.copy(this.topic[obj]);
            }
            else if (objArray.length === 2) {
                if (angular.isUndefined(this.topic[objArray[0]][objArray[1]])) {
                    this.topic[objArray[0]][objArray[1]] = [];
                }
                this.temp[objArray[0]][objArray[1]] = angular.copy(this.topic[objArray[0]][objArray[1]]);
            }
            else {
                //alert('Problem with moving into edit mode ' + obj);
                return this.editableComponents[obj].editMode = false;
            }
            return this.editableComponents[obj].editMode = true;
        }
        else {
            //alert('You are not authorized to modify ' + obj);
            return this.editableComponents[obj].editMode = false;
        }
    };
    /** setTempFromTopicPartFiles - Change the edit mode to true false of the component & assign either the temp or topic data for files
     * @param {string}    comp:   object we want copy from topic to temp
     */
    TopicService.prototype.setTempFromTopicPartFiles = function (comp) {
        var section = comp.replace('files$', '');
        var tempFiles = [];
        if (angular.isDefined(this.temp.files)) {
            angular.forEach(this.temp.files, function (file) {
                if (file.type !== section &&
                    !(section === 'sampling_SSA' && file.type === 'sampling')) {
                    tempFiles.push(file);
                }
            });
        }
        if (angular.isDefined(this.topic.files)) {
            angular.forEach((this.topic.files), function (file) {
                if (file.type === section ||
                    (section === 'sampling_SSA' && file.type === 'sampling')) {
                    tempFiles.push(file);
                }
            });
        }
        else {
            return this.editableComponents[comp].editMode = false;
        }
        if (angular.isDefined(this.editableComponents[comp]) && comp !== '' && this.editableComponents[comp].editable) {
            this.temp.files = tempFiles;
            return this.editableComponents[comp].editMode = true;
        }
        else {
            return this.editableComponents[comp].editMode = false;
        }
    };
    /** setTopicFromTempPart - Change the edit mode to false of the component & copy from temp to topic
     * @param {string}    obj:   object we want copy from temp to topic
     */
    TopicService.prototype.setTopicFromTempPart = function (obj) {
        if (angular.isDefined(this.editableComponents[obj]) && obj !== '' && this.editableComponents[obj].editable) {
            if (obj === 'calculation' && this.topic.calculationVersion >= 2) {
                this['calculation'] = angular.copy(this.temp['calculation']);
            }
            var objArray = obj.split('$');
            if (objArray.length === 1) {
                this.topic[obj] = angular.copy(this.temp[obj]);
            }
            else if (objArray.length === 2) {
                this.topic[objArray[0]][objArray[1]] = angular.copy(this.temp[objArray[0]][objArray[1]]);
            }
            else {
                alert('Problem with moving out of edit mode ' + obj);
                return this.editableComponents[obj].editMode = true;
            }
            return this.editableComponents[obj].editMode = false;
        }
        else {
            //alert('You are not authorized to modify ' + obj);
            return this.editableComponents[obj].editMode = true;
        }
    };
    TopicService.prototype.cancelEdit = function (obj) {
        if (angular.isDefined(this.editableComponents[obj]) && obj !== '' && this.editableComponents[obj].editable) {
            return this.editableComponents[obj].editMode = false;
        }
        else {
            return false;
        }
    };
    TopicService.prototype.getEditComponent = function (obj) {
        if (angular.isDefined(this.editableComponents[obj]) && obj !== '' && this.editableComponents[obj].editable) {
            return this.editableComponents[obj];
        }
        else {
            return false;
        }
    };
    TopicService.prototype.clearTempComments = function () {
        this.temp.elig_dec_text = '';
    };
    // Sets the active tab - so we know which one should be highlighted
    TopicService.prototype.setActiveTab = function (tab) {
        this.tabs.activeTab = tab;
        this.tabs.short = tab.replace('detail.', '');
    };
    // Set the tabs in the details view
    TopicService.prototype.setTabList = function (list, program) {
        var _this = this;
        if (angular.isUndefined(list)) {
            list = { general: true };
        }
        switch (program) {
            case 'SVI':
                this.visibleTabs = {
                    eligibility: true,
                    general: true,
                    payment: true,
                    sampling: true,
                    validation: true
                };
                break;
            default:
                this.visibleTabs = {
                    general: true
                };
        }
        this.tabs.list = [
            {
                editable: list.general,
                name: 'detail.general',
                title: 'General',
                visible: this.visibleTabs.general
            }, {
                editable: list.eligibility,
                name: 'detail.eligibility',
                title: 'Eligibility',
                visible: this.visibleTabs.eligibility
            }, {
                editable: list.validation,
                name: 'detail.validation',
                title: 'Sales Order Validation',
                visible: this.visibleTabs.validation
            }, {
                editable: list.sampling,
                name: 'detail.sampling',
                title: 'Sales Document Verification',
                visible: this.visibleTabs.sampling
            }, {
                editable: list.payment,
                name: 'detail.payment',
                title: 'Calculation & Payment',
                visible: this.visibleTabs.payment
            },
        ];
        angular.forEach(this.tabs.list, function (tab) {
            if (tab.name === _this.$state.current.name) {
                if (!tab.editable || !tab.visible) {
                    _this.setActiveTab('detail.general');
                    _this.$state.go('detail.general');
                }
            }
        });
    };
    /*
        //Sets if the tab is in edit mode
        setEditMode( value: any ) {
          this.tabs.editMode = value;
        }
    */
    TopicService.prototype.addFiles = function (fileNames) {
        var _this = this;
        angular.forEach(fileNames, function (fileName) {
            var fileFound = false;
            angular.forEach(_this.topic.files, function (att) {
                if (angular.isDefined(att.name)) {
                    if (fileName.name === att.name) {
                        fileFound = true;
                    }
                }
            });
            if (!fileFound) {
                // If file is not found push it into the file array
                _this.topic.files.push(fileName);
            }
        });
    };
    TopicService.prototype.deleteFiles = function (fileNames) {
        return this.topic_ext.attachments.filter(function (el) { return !fileNames.includes(el.name); });
    };
    TopicService.prototype.getId = function (fullDMTId) {
        //Id will be DMT-xxxxxxxxxx...we just want the part after DMT- as that is what is used
        //as the unique reference in the db2 tables
        return fullDMTId.substring(4);
    };
    /**
     * Function called from the site body after a dispute has been created, but only if the user
     * chooses NOT to open the new dispute and remain on the current document
     */
    TopicService.prototype.addDisputeDetails = function (bundle) {
        if (angular.isDefined(bundle.history)) {
            this.topic.status.history.push(bundle.history);
        }
        //Check if any disputes have been raised before
        if (this.topic.disputes) {
            this.topic.disputes.push(bundle.unid);
        }
        else {
            this.topic.disputes = [bundle.unid];
        }
    };
    TopicService.prototype.deleteFederalDisbursement = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'deleteFederal',
                script: 'federal/federal',
                opp: this.topic.opp,
                id: this.topic._id,
                token: this.env.user.token,
                user: this.env.user
            }
        });
    };
    /**
     * Function to simply reset the gpp comparison data - will be called when doc is opened each time or f5 pressed
     * or if a GPP reload takes place
     */
    TopicService.prototype.resetCompareGppData = function () {
        this.compareGpp = {
            gpp: {},
            gppMissing: [],
            gppSection: {
                bf: {
                    status: false,
                    variables: ['row_id', 'billdate', 'level10prod', 'brandfam', 'brand', 'winprob', 'revn_qty', 'price', 'revenue',
                        'salesorder', 'brandfamsviparticip', 'brandcert', 'salesstage', 'crncy', 'x_svi_status',
                    ]
                },
                st: {
                    status: false,
                    variables: []
                },
                or: {
                    status: false,
                    variables: ['inctvname', 'inctvstat', 'reqdate', 'approvalident', 'bustype', 'competitor',
                        'sernumreplaced', 'inctvexpdate', 'bpname',
                    ]
                },
                svi: {
                    status: false,
                    variables: ['row_id', 'level10prod', 'brandfam', 'revn_qty', 'price', 'revenue', 'crncy',
                        'x_svi_status', 'dup_opp_flg', 'dup_opp_num', 'svicmnt',
                    ]
                },
                ci: {
                    status: false,
                    variables: ['lname', 'fname', 'wrkphone', 'jobtitle', 'email', 'account', 'cellphone']
                },
                ods: {
                    status: false,
                    variables: []
                }
            }
        };
    };
    TopicService.prototype.setUSFed = function (goeSection) {
        //If set to Yes/Unknown and US radio not set, set as false, or If is was set to Yes but user now clicks No...set to No
        if ((this.temp && this.temp[goeSection] && ['Yes', 'Unknown', 'State Owned'].indexOf(this.temp[goeSection].picked) > -1 && this.temp[goeSection].usfederal === undefined) ||
            (this.temp && this.temp[goeSection] && ['No'].indexOf(this.temp[goeSection].picked) > -1 && this.temp[goeSection].usfederal === true)) {
            this.temp[goeSection].usfederal = false; //set default as false (No)
            this.usFed.status = false;
        }
    };
    TopicService.prototype.confirmUSFederal = function (event) {
        var _this = this;
        if (!this.env.user.access.nonBpsoAdmin) {
            var items = {
                icon: 'ERROR',
                message: 'Only Non-BPSO Administrators have authority to continue.',
                title: 'Restricted'
            };
            this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) { return; });
        }
        else {
            //Prepare to ask question...based on event
            var items = {
                icon: 'QUESTION',
                message: '<b>FINAL WARNING</b>: Upon confirming this Disbursement as a US Federal opportunity, the record will be removed from DMT permanently. &nbsp;Continue?',
                title: 'US Federal Opportunity'
            };
            //Ask it...
            this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
                if (dResult.confirm) {
                    //make call to delete all trace of the record EXCEPT the Summary data in the Queue
                    _this.topic.usFed.beingDeleted = true;
                    _this.topic.deleteFederalDisbursement();
                }
            });
        }
    };
    /**
     * Function called from site.body when refreshed checklists are received
     * @param checklists
     */
    TopicService.prototype.updateRefreshedChecklists = function (data) {
        var _this = this;
        //Loop through the array and update the topic
        angular.forEach(data.chk, function (cl) {
            _this.topic[cl.name] = cl.checklist;
        });
        this.topic.complete = data.cmpl;
    };
    TopicService.prototype.isGOE = function () {
        var eGEC = angular.isDefined(this.topic.goe) && angular.isDefined(this.topic.goe.picked) && this.topic.goe.picked !== '' ? this.topic.goe.picked : undefined;
        var vGEC = angular.isDefined(this.topic.goe_valid) && angular.isDefined(this.topic.goe_valid.picked) && this.topic.goe_valid.picked !== '' ? this.topic.goe_valid.picked : undefined;
        var GE_Decision = eGEC;
        //Where we at?  If beyond Elig, take the Validation entry...if that's not there, take elig
        if (this.topic.status.status_no > 3) {
            if (angular.isDefined(vGEC)) {
                GE_Decision = vGEC;
            }
        }
        if ((['US', 'CA'].indexOf(this.topic.country) > -1 && GE_Decision === 'Yes') //If US and goe is Yes
            || (['US', 'CA'].indexOf(this.topic.country) === -1 && ['Yes', 'Unknown'].indexOf(GE_Decision) > -1)) {
            return true;
        }
        return false;
    };
    /**
     * Function to detetrmine whether or not a 2nd GOE needs to be performed in the Validation tab.
     * It will only be required if:
     * - Country is US or Canada and the Eligibility GOE Decision is 'No' or 'Unknown'
     * - Country is anything else and the Eligibility GOE Decision is 'No'
     *
     * @returns {boolean}
     *
     * @memberof TopicService
     */
    TopicService.prototype.is2ndGOENeeded = function () {
        if ((['US', 'CA'].indexOf(this.topic.country) === -1 && this.topic.goe.picked === 'No') //If not US and goe is No
            || (['US', 'CA'].indexOf(this.topic.country) > -1 && ['No', 'Unknown'].indexOf(this.topic.goe.picked) > -1)) {
            return true;
        }
        return false;
    };
    TopicService.prototype.is2ndGOEComplete = function () {
        if (angular.isDefined(this.topic.cmr_valid) && angular.isDefined(this.topic.cmr_valid.decision) && angular.isDefined(this.topic.cmr_valid.decision.success)) {
            return true;
        }
        return false;
    };
    TopicService.prototype.strRight = function (value, len) {
        if (len < value.length) {
            return value.substring(value.length - len);
        }
        return value;
    };
    TopicService.prototype.useBPOI = function () {
        if (!this.topic.goe || !this.topic.goe.picked
            || !this.topic.states || !this.topic.states.bpoi) {
            return false;
        }
        else if ((!this.is2ndGOENeeded() && this.topic.states.bpoi.geYes)
            || (this.is2ndGOENeeded() && this.topic.states.bpoi.geNo)) {
            return true;
        }
        else {
            return false;
        }
    };
    TopicService.prototype.attachmentsFound = function (fileType) {
        //Loop through all the files looking for a type fcmr_valid, ie: ad-hoc attachments in Find CMR Validaltion
        var attachmentsFound = false;
        angular.forEach(this.topic.files, function (file) {
            if (file.type === fileType) {
                attachmentsFound = true;
            }
        });
        return attachmentsFound;
    };
    TopicService.prototype.getGOEValidStatus = function () {
        var _this = this;
        //Are there Find CMR results...could be auto (via 2nd GOE) or manual
        var avcmrErr = 0;
        var searchCount = 0;
        var manCount = 0;
        var decisionErrors = [];
        if (angular.isDefined(this.topic.cmr_valid) && angular.isDefined(this.topic.cmr_valid.results) && this.topic.cmr_valid.results.length > 0) {
            angular.forEach(this.topic.cmr_valid.results, function (cmr) {
                searchCount++; //sum up the number of searches made
                //If auto one found...
                if (cmr.ds === 'AVCMR') {
                    //Loop through results
                    angular.forEach(cmr.table, function (row) {
                        //If the nonToGoe is true...that's an error
                        if (row.nonToGoe) {
                            avcmrErr++;
                        }
                    });
                    //Since it's an auto GOE, check the Decision, too...if that's an error, add it
                    if (!_this.topic.cmr_valid.decision.success) {
                        decisionErrors = _this.topic.cmr_valid.decision.errors;
                    }
                }
                else {
                    manCount++;
                }
            });
        }
        return {
            auto: searchCount - manCount,
            manual: manCount,
            errors: avcmrErr,
            decerrs: decisionErrors
        };
    };
    TopicService.prototype.isBaseSampling = function () {
        if ((this.getIncentiveType() === 'CVR Sales Assist' || this.getIncentiveType() === 'Sales Assist') &&
            this.topic.status.status_no === 4 &&
            !this.isGOE() &&
            !this.areCalcsStarted()) {
            return true;
        }
        return false;
    };
    TopicService.prototype.isNewUI = function () {
        // Check if svisubmitdate is before the date in the file - cut-over date is the gpp/mysa cutover - everything
        // after this date is subject to new ui and dupe checks
        var mysaCutoverDate = this.settings.dmtModuleHeaderUpdateDate;
        var submitDate = Number(this.topic.gpp[0].svisubmitdate);
        this.topic.newUI = false;
        if (submitDate && mysaCutoverDate && submitDate >= mysaCutoverDate) {
            this.topic.newUI = true;
        }
    };
    TopicService.prototype.isSamplingStarted = function (incentive) {
        var sampl = this.topic.sampling[incentive] || this.topic.sampling;
        if (!_.isUndefined(sampl) && !_.isUndefined(sampl.samplingStatus)) {
            if (sampl.samplingStatus !== 'untested') {
                return true;
            }
            return false;
        }
        return false;
    };
    TopicService.prototype.isSamplingComplete = function (incentive) {
        var sampl = this.topic.sampling[incentive] || this.topic.sampling;
        // The statuses that mean Sampling is complete
        var finalSampStatuses = [
            'Manually sampled - Failed',
            'Manually sampled - Passed',
            'Manual override',
            'Passed',
            'Failed'];
        if (!_.isUndefined(sampl) && !_.isUndefined(sampl.samplingStatus)) {
            if (finalSampStatuses.indexOf(sampl.samplingStatus) > -1) {
                return true;
            }
            return false;
        }
        return false;
    };
    TopicService.prototype.getIncentiveType = function () {
        if (!_.isUndefined(this.topic.sales_assist) && !_.isUndefined(this.topic.sales_assist.type)) {
            return this.topic.sales_assist.type;
        }
        return 'Unknown';
    };
    TopicService.prototype.areCalcsStarted = function () {
        if (this.topic.calculation) {
            return true;
        }
        return false;
    };
    TopicService.prototype.isNotInEligibilityStatus = function () {
        if (this.topic.status.status_no === 3 && [3, 4, 23, 28, 29, 32, 33].indexOf(this.topic.status.sub_status_no) !== -1) {
            return true;
        }
        return false;
    };
    TopicService.prototype.isEligibilityDecisionButtonHide = function () {
        return this.isNotInEligibilityStatus() || this.topic.status.status_no > 3;
    };
    // used to reload during assignment
    TopicService.prototype.isInitialV3 = function () {
        if (this.topic.status.status_no === 1 && this.topic.status.sub_status_no === 3) {
            return true;
        }
        return false;
    };
    /**
     * Function to reload the current opp
     * @param stateParamId
     */
    TopicService.prototype.reloadDisbursement = function (stateParamId) {
        //Reload!!
        var gppOpp = this.topic.opp;
        this.clearTopic(stateParamId);
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'loadDataClient',
                script: '/detail/general/general',
                data: {
                    opp: gppOpp,
                    unid: 'DMT-' + stateParamId
                },
                token: this.env.user.token
            }
        });
    };
    /**
     * Function to determine if the Disbursement has an owner
     */
    TopicService.prototype.hasOwner = function () {
        if (angular.isUndefined(this.topic.owner) || this.topic.owner === '') {
            return false;
        }
        return true;
    };
    /**
     * Function to determine if the Disbursement is in a Pre-Sales Order Validation status
     */
    TopicService.prototype.isValidationPreSalesOrder = function () {
        if (this.topic.status.status_no === 4 && (angular.isUndefined(this.topic.sap) || this.topic.sap.length === 0)) {
            return true;
        }
        return false;
    };
    /**
     * Determine if the disbursement has any unresolved errors
     */
    TopicService.prototype.hasUnresolvedErrors = function () {
        if (angular.isDefined(this.topic.errors) && this.topic.errors.unresolved > 0) {
            return true;
        }
        return false;
    };
    /**
     *
     * @param {string} comp
     * return
     */
    TopicService.prototype.checkNewClientEditMode = function (comp) {
        var isEditModeOn = this.editableComponents[comp].socket !== '';
        // || (_.has(this, 'checksData.result.NC')
        //     && _.has(this, 'topic.nc.results')
        //     && !_.has(this, 'checksData.result.NC.error'));
        this.editableComponents[comp] = isEditModeOn
            ? {
                editable: false,
                editMode: false,
                socket: 'Not Editable'
            } : {
            editable: true,
            editMode: false,
            socket: ''
        };
        return !!this.editableComponents[comp].socket;
    };
    /**
     * Return full name of the country (example "US" => "USA")
     *
     * @param {string} countryShort
     * @returns {string}
     * @memberof TopicService
     */
    TopicService.prototype.getCountryFullName = function (countryShort) {
        var countryInfo = this.config.settings.country_list.find(function (e) { return e.short === countryShort; });
        return countryInfo ? countryInfo.country : '';
    };
    //if the socket response is from the opp number that sent the req socket
    TopicService.$inject = ['$rootScope', '$timeout', '$q', 'socket', 'config', '_', 'status', 'settings', 'env', '$state', 'notify', 'Dialog'];
    return TopicService;
}());
TopicService = TopicService;
angular
    .module('application')
    .service('topic', TopicService);

//# sourceMappingURL=topic.js.map
